import { Tooltip } from 'components';
import PropTypes from 'prop-types';
import { QuestionIcon } from 'assets/icons';

import styles from './styles.module.scss';

function GuideTooltip({ tooltipText, tooltipWidth, placement, offsetValue }) {
  const tooltipAdditionalStyle = { width: tooltipWidth };

  return (
    <Tooltip
      additionalStyle={tooltipAdditionalStyle}
      message={tooltipText}
      placement={placement}
      offsetValue={offsetValue}
    >
      <img className={styles.question_icon} src={QuestionIcon} alt='guide' />
    </Tooltip>
  );
}

GuideTooltip.defaultProps = {
  tooltipWidth: 170,
  placement: 'top',
  offsetValue: 8,
};

GuideTooltip.propTypes = {
  tooltipText: PropTypes.string.isRequired,
  tooltipWidth: PropTypes.number,
};

export default GuideTooltip;
